import { axiosInstance, axiosInstanceExporters } from ".";

const getVoucherRequestsList = async ({ params }) =>
  await axiosInstance.get("/api/Voucher/GetRequests", {
    params
  });

const getVouchersUsedNotUsedList = async ({ params }) =>
  await axiosInstanceExporters.get("/api/Voucher/Get", {
    params
  });

const generateVoucher = async (data) =>
  await axiosInstance.post("/api/Voucher/GenerateVoucher", data);

export {
  getVoucherRequestsList,
  getVouchersUsedNotUsedList,
  generateVoucher
};
